import m from "../../geodata/es2015/portugalLow";
window.am4geodata_portugalLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/portugalLow.js
// module id = null
// module chunks = 